import React from "react";
import FAQ from "../../Components/FAQ/Faq";
import "./FAQs.css";

const FAQs = () => {
  return (
    <div className="container">
      <h2 style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}>
        FAQ's
      </h2>
      <FAQ
        question="What is BetaHome.ng?"
        answer="Betahome.ng is a Platform That helps customers To purchase furniture and interior decor item with the support of our funding partners.Customers  can repay over 3 to 12 months period At a low interest rate."
      />
      <FAQ
        question="⁠How does the funding process work?"
        answer={
          <>
            Select your desired betahome.ng Flexpay package furniture/decor or
            from our partner vendors.
            <br />
            Apply for financing through BetaHome.ng funding partners.
            <br />
            Get matched with a funding partner.
            <br />
            Repay in flexible installments (3-12 months) with interest.
          </>
        }
      />
      <FAQ
        question="What is the interest rate?"
        answer="Interest rates vary based on the funding partner and repayment duration. You’ll see the applicable rate before confirming your purchase."
      />
      <FAQ
        question="Which vendors are supported?"
        answer="We partner with trusted furniture and interior decor vendors. Browse our app or website to see available options."
      />
      <FAQ
        question="Can I pay off my loan early?"
        answer="Yes! Early repayment is allowed, and some partners may offer reduced interest. Check your loan terms for details."
      />
      <FAQ
        question="What happens if I miss a payment?"
        answer={
          <>
            Late payments may attract penalties or affect your credit score.
            <br />
            Contact your funding partner immediately if you foresee delays.
            <br />
            Clients that fail to pay up the balance as at when due will be
            fined, penalized, and reported to the appropriate authority for
            contract default.
            <br />
            Court injunction will be taken if and when needed to retrieve the
            product from defaulting clients.
          </>
        }
      />
      <FAQ
        question="How do I apply?"
        answer="Download the BetaHome.ng app or visit our website, select your items, and complete the financing application."
      />
      <FAQ
        question="Is my data secure?"
        answer={
          <>
            Yes! We use secure encryption to protect your personal and financial
            information.
            <br />
            Need more help? Contact us at [admin@betahome.ng]
            <br />
            Furnish your home now, pay later with BetaHome.ng!
          </>
        }
      />

      <FAQ
        question="Is BetaHome.ng Free?"
        answer="Downloading the BetaHome.ng mobile app and creating an account are both completely free. However, you will be required to pay for each good and service that is provided to you over the platform. You have the option to choose anyone who fits your price range and budget from the wide range of product and service providers that are available."
      />
      <FAQ
        question="How does BetaHome.ng benefit furniture vendors?"
        answer={
          <>
            Increase sales: Customers who can’t afford upfront payments can
            still buy from you.
            <br />
            Faster payments: Get paid immediately by our funding partners—no
            waiting for installments.
            <br />
            Broader customer base: Attract more buyers who prefer flexible
            payment options.
            <br />
            Zero risk: BetaHome.ng funding partners handle repayment, reducing
            your exposure to bad debt.
          </>
        }
      />
      <FAQ
        question="How does the funding process work for furniture vendor customers?"
        answer={
          <>
            Customer selects furniture/decor from your store.
            <br />
            They apply for financing via BetaHome.ng (app or website).
            <br />
            Approval in minutes—funding partners assess eligibility.
            <br />
            You receive full payment once approved.
            <br />
            Customer repays BetaHome.ng funding partner in 3-12 months (with
            interest).
          </>
        }
      />
      <FAQ
        question="Do I need to sign a contract to partner with BetaHome.ng?"
        answer={
          <>
            Yes, vendors must complete a simple onboarding process to ensure
            smooth transactions. This includes:
            <br />
            Business verification
            <br />
            Agreement on payment terms
            <br />
            Integration (if selling online)
          </>
        }
      />
      <FAQ
        question="How and when do I get paid?"
        answer="Once a customer’s financing is approved, BetaHome.ng’s funding partner pays upfront, You don’t wait for the customer’s instalments."
      />
      <FAQ
        question="What if a customer defaults on repayment?"
        answer="BetaHome.ng funding partners handle all collections. You receive full payment upfront, so you bear no risk of non-payment. "
      />
      <FAQ
        question="Are there any costs for vendors?"
        answer="BetaHome.ng does not charges the vendor (details provided during onboarding). There are no hidden charges—you receive the agreed"
      />

      <FAQ
        question="How do I purchase BetaHome.ng products?"
        answer="When you register to buy any of the products offered on the BetaHome.ng platform, you have the option of paying in full up front or using an installment payment plan of your choice."
      />
      <FAQ
        question="Do You Have A Showroom?"
        answer="No, we are a marketplace company with various merchants listing their product for sale on our platform."
      />
      <FAQ
        question="How Does It Work?"
        answer={`1. Choose the Product Package You Prefer:\n2. Sign the sales contract\n3. Select a payment plan\n4. Pay in instalments\n5. Select a shipping date.\n6. BetaHome.ng agents deliver the order and assemble it (between 5–10 working days).`}
      />
      <FAQ
        question="How do I make payment for BetaHome.ng Products?"
        answer="Every BetaHome.ng product and service must be paid for using the payment gateway offered and approved on the platform. In the case of an instant cash payment, customers or prospects may only make such payments to a third party (Beta Ambassador) with BetaHome.ng's prior approval and clearance to handle such payment transactions on the company's behalf."
      />
      <FAQ
        question="How long does it take to complete payment for any BetaHome.ng Products? "
        answer="Customers or clients of BetaHome.ng may pay in full at once or over the course of a minimum of one month and a maximum of three months. 
Customers who pay BetaHome.ng in instalments must pay 80% up advance within two months before the products are delivered and 20% within thirty days after the delivery date. 
Customers and clients can choose from three different payment schedules: daily, weekly, and monthly, depending on their budget for installment payments
"
      />
      <FAQ
        question="How do I become a Beta Ambassador?"
        answer="
           By signing up to sell BetaHome.ng products and 
           services you can make money selling BetaHome.ng 
           products at your own convenience even while you work.
           You can become a beta ambassador of BetaHome.ng by using
           your personality to market and create brand awareness for
          BetaHome.ng products and services to a prospective 
          buyer/client for a commission."
      />
      <FAQ
        question="How do I make money as Beta Ambassador?"
        answer="
        You can earn money at your convenience by promoting BetaHome.ng products, and you are able to create a side hustle that will pay you a sizable commission bonus only for referring prospects or new customers to BetaHome.ng products using your referral code."
      />
      <FAQ
        question="What do I need to become a Beta Ambassador?"
        answer="
        As a beta ambassador, you must submit certain details that will be used to generate and create an individual profile that includes a referral code, your unique ID for claiming commission for each transaction made through your channel."
      />
      <FAQ
        question="How do I get a referral code?"
        answer="
        By completing the Beta Ambassador sign-up form with 
        complete information about yourself, which will be used to
        create a unique user ID for you to use as a referral code when
        introducing BetaHome.ng 
        products to potential new clients or customers."
      />
      <FAQ
        question="What do I need to sign up as Beta Ambassador?"
        answer="
        You must enter your name, phone number, bank information, and DOB, BVN, or NIN. Only verified beta ambassadors on the platform will receive the 
        commission bonus from BetaHome.ng; any beta ambassador 
        prospects who provide inaccurate or inappropriate information 
        will have their access to the platform suspended. Examples of 
        such information include phone number, date of birth, and bank account information."
      />
      <FAQ
        question="Will I find all kinds of service providers on BetaHelp?"
        answer="
        More than 200 services are presently listed 
        by BetaHelp on the site, and thousands more providers 
        are available to meet a variety of user needs. 
        As more areas are requested by users, updates are frequently 
        made to cover them. To fulfill the expanding user expectations, 
        more service providers (Partners) are joining every day.."
      />
      <FAQ
        question="Can I also register as a service provider on BetaHelp?"
        answer="
        Yes, as an unskilled worker, technician, merchant, or professional who provides services in exchange for payment. You may quickly create your service profile and payment wallet by registering as a Partner on betahelp. Once that process is complete, you may begin providing services. You can also become a vendor that sells the raw materials required to carry out such services from your business to clients nearby and earn money every day."
      />
      <FAQ
        question="Can I render any kind of service?"
        answer="
        With BetaHome.ng, you may help individuals 
        with their daily requirements and find solutions to issues. 
        You are welcome to join Betahelp as a partner if you 
        are able to use your abilities as a person to provide these 
        services that meet these requirements, lending your voice to 
        romote BetaHome.ng as a brand, their products, and services, 
        thereby persuading and convincing new potential customers to buy the products. You can also mentor and guide other people to sell BetaHome.ng products and services as a beta ambassador 
        for a commission bonus while attending to your clients' needs."
      />
      <FAQ
        question="BetaHome.ng is available on all android & iOS devices"
        answer="
        If your smartphone is an Android model, 
        go to the Google Play Store and download BetaHome.ng 
        to get started. If you use iOS, don't worry—we've got you 
        covered. 
        Visit the Apple Store and download BetaHome.ng to get started."
      />
      <FAQ
        question="Can I Choose the Delivery Date and Time?"
        answer="
        Of course, you get to pick the day and hour. 
        Please consult our customer service team by phone 
        or email at help@betahme.ng."
      />
      <FAQ
        question="Do I get a  refund if I stop installment payment for a product?"
        answer="
        Because BetaHome.ng is not a financial institution that allows deposits and withdrawals, you won't receive a refund for payments made to our corporate bank account. However, in the event that a customer is unable to meet the deadline for a payment obligation, BetaHome.ng will in that case revise and revamp the deadline in accordance with the client's specific request."
      />
      <FAQ
        question="Can I Create My Package?"
        answer="
        You may create a package based on your preferences, yes. The customer can place a special order for additional items in the color and pattern of their choice, and BetaHome.ng will send them a pricing quotation in response to their purchase request. 
Unable to find a good response? Inform us of your needs."
      />
    </div>
  );
};

export default FAQs;

// Frequently Asked Questions (FAQ) – BetaHome.ng

// 1. What is BetaHome.ng?
// BetaHome.ng is a platform that connects customers with funding partners to help them purchase furniture and interior decor from vendors. Customers can repay over 3 to 12 months with an applicable interest rate.

// 2. How does the funding process work?

// Select your desired betahome.ng Flexpay package furniture/decor or from our partner vendors.

//

// Get matched with a funding partner.

// Repay in flexible installments (3-12 months) with interest.

// 3. What is the interest rate?
// Interest rates vary based on the funding partner and repayment duration. You’ll see the applicable rate before confirming your purchase.

// 4. Which vendors are supported?
// We partner with trusted furniture and interior decor vendors. Browse our app or website to see available options.

// 5. Can I pay off my loan early?
// Yes! Early repayment is allowed, and some partners may offer reduced interest. Check your loan terms for details.

// 6. What happens if I miss a payment?
// Late payments may attract penalties or affect your credit score. Contact your funding partner immediately if you foresee delays.
//   Clients that fail to pay up the balance as at when due will be fined, penalized, and reported to the appropriate authority for contract default.
// Court injunction will be taken if and when needed to retrieve the product from defaulting clients.
// 7. How do I apply?
// Download the BetaHome.ng app or visit our website, select your items, and complete the financing application.

// 8. Is my data secure?
// Yes! We use secure encryption to protect your personal and financial information.

// Need more help? Contact us at [admin@betahome.ng]

// Furnish your home now, pay later with BetaHome.ng!
